<template>
  <a-card title="Details">
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <!-- <a-alert :class="getScreen ? 'margin-bottom' : ''" :type="sisa_penarikan == 0 ? 'success' : 'error'" show-icon>
          <span slot="message">{{ formatCurrency("", sisa_penarikan) }}</span>
          <span slot="description"
            >Sisa jumlah fasilitas yang belum dijadwalkan</span
          >
        </a-alert> -->
        <a-form-model ref="detailsForm" :model="form" :rules="rules">
          <!-- <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-model-item label="Month" prop="bulan">
                <a-month-picker
                  v-model="form.bulan"
                  format="MMMM"
                  placeholder="Select month"
                ></a-month-picker>
              </a-form-model-item>
              <!-- <a-form-model-item label="Date" prop="date">
                      <a-date-picker
                        :format="getDefaultDateFormat"
                        v-model="form.date"
                      />
                    </a-form-model-item> --
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-model-item label="Year" prop="tahun">
                <a-date-picker
                  v-model="form.tahun"
                  mode="year"
                  format="YYYY"
                  :open="yearPicker.isOpen"
                  @panelChange="
                    (v) => {
                      yearPicker.isOpen = false;
                      form.tahun = v;
                    }
                  "
                  @openChange="
                    !yearPicker.isOpen
                      ? (yearPicker.isOpen = true)
                      : (yearPicker.isOpen = false)
                  "
                  placeholder="Select year"
                ></a-date-picker>
              </a-form-model-item>
              <!-- <a-form-model-item label="File Document" prop="doc_dtl">
                      <template v-if="isEdit">
                        <div class="doc-viewer edit">
                          <div class="detail">
                            <a-button-group size="small">
                              <a-upload
                                accept="*"
                                :showUploadList="false"
                                :beforeUpload="beforeUpload"
                              >
                                <a-button size="small" icon="upload">
                                  Change File
                                </a-button>
                              </a-upload>
                              <a-button
                                @click="handleRevert"
                                type="primary"
                                v-if="form.doc_dtl"
                                icon="reload"
                              ></a-button>
                            </a-button-group>
                            <h4 class="margin-remove m-text-dots">
                              {{
                                this.form.doc_dtl == null
                                  ? this.form.doc_existing_dtl
                                  : this.form.doc_dtl.name
                              }}
                            </h4>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <a-upload
                          accept=".pdf"
                          :showUploadList="false"
                          :beforeUpload="beforeUpload"
                        >
                          <div class="upload">
                            <a-button icon="upload">Select File </a-button>
                          </div>
                        </a-upload>
                        <div
                          class="doc-viewer"
                          v-if="form.doc_dtl !== null"
                        >
                          <a-button
                            type="danger"
                            ghost
                            size="small"
                            class="close"
                            icon="close"
                            @click="removeUploadFile()"
                          ></a-button>
                          <div class="detail">
                            <h4 class="margin-remove m-text-dots">
                              {{
                                JSON.parse(
                                  JSON.stringify(form.doc_dtl.name)
                                )
                              }}
                            </h4>
                          </div>
                        </div>
                      </template>
                    </a-form-model-item> --
            </a-col>
          </a-row> -->
          <a-form-model-item label="Type Companion" prop="type_companion">
            <a-radio-group buttonStyle="solid" v-model="form.type_companion" @change="changeTypeCompanion">
              <a-radio-button value="FC">Full Cover</a-radio-button>
              <a-radio-button value="IS">Insurance</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="Method" prop="methode" v-if="form.type_companion == 'FC'">
            <a-radio-group buttonStyle="solid" v-model="form.methode">
              <a-radio-button value="BM">Balance Minus</a-radio-button>
              <a-radio-button value="BF">Blocked Fund</a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="Companion Name" prop="companion_nm">
            <a-input v-model="form.companion_nm"></a-input>
          </a-form-model-item>
          <a-form-model-item label="Contact person" prop="contact_person">
            <a-input v-model="form.contact_person"></a-input>
          </a-form-model-item>
          <!--a-form-model-item label="No Telp" prop="no_telp">
          <a-input v-model="form.no_telp"></a-input>
        </a-form-model-item-->
          <a-form-model-item label="Nominal" prop="nominal">
            <a-input-number :min="0" :initialValue="0" class="m-width-full m-text-align right" :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              " :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" v-model="form.nominal"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Return Date" prop="return_dt">
            <a-date-picker v-model="form.return_dt" placeholder="Select Date" format="DD-MM-YYYY"></a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="Note" prop="note">
            <a-textarea v-model="form.note" :rows="3"></a-textarea>
          </a-form-model-item>
          <a-button-group class="action">
            <a-button type="primary" :block="changeDetail.status ? false : true" :icon="changeDetail.status ? '' : 'plus'"
              @click="handleSubmit">{{ changeDetail.status ? "Submit Change" : "Add Companion" }}
            </a-button>
            <a-button v-if="changeDetail.status" @click="handleCancelEdit" icon="close" type="default">Cancel</a-button>
          </a-button-group>
        </a-form-model>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-table key="tbl_dtl_1" rowKey="id_dtl" bordered :data-source="getDataDtlForm" :pagination="false"
          :columns="columns" :scroll="{ x: 800 }">

          <span slot="no" slot-scope="item,record, index">
            {{ index + 1 }}
          </span>
          <span slot="companion_nm" slot-scope="item">
            <b>{{ item.companion_nm }}</b><br />
            <small>[Type: {{ item.type_companion == "FC" ? "Full Cover" : "Insurance" }}]</small>
          </span>
          <span slot="total" slot-scope="item">
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(item)" />
          </span>
          <span slot="nominal" slot-scope="item">
            <div class="m-text-align right">
              <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(item.nominal)" />
            </div>
          </span>
          <span slot="contact_person" slot-scope="item">
            {{ item.contact_person }}
            <!--small>[No.Telp.: {{item.no_telp}}]</small-->
          </span>
          <span slot="return_dt" slot-scope="item">
            {{ moment(item.return_dt).format('DD-MM-YYYY') }}
          </span>
          <span slot="methode" slot-scope="item">
            {{ item.methode == 'FC' ? 'Full Cover' : (item.methode == 'BF' ? 'Blocked Fund' : '-') }}
          </span>
          <a-button-group slot="action" slot-scope="item">
            <a-button @click="handleEdit(item)" icon="edit" :disabled="item.delete_button == 'disabled'" />
            <a-button @click="handleRemove(item)" :disabled="(changeDetail.selected.length > 0 && changeDetail.selected.id == item.id) ||
              (item.delete_button && item.delete_button == 'disabled')" icon="delete" type="danger" />
          </a-button-group>
          <!-- <ul class="table-footer" slot="footer">
            <li>
              <span>Total Principal of Payment</span>
              <h3>{{ formatCurrency("IDR", sum_table_pokok) }}</h3>
            </li>
            <li>
              <span>Total Bank Interest</span>
              <h3>{{ formatCurrency("IDR", sum_table_bunga) }}</h3>
            </li>
            <li>
              <span>Grand Total </span>
              <h3>{{ formatCurrency("IDR", sum_table_total) }}</h3>
            </li>
          </ul> -->
        </a-table>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import nanoid from "nanoid";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "DetilBidBondRequest",
  props: {
    dataProcessed: {},
    mode: String,
    type: String,
  },
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    const columns = [
      {
        title: "No",
        key: "key",
        align: "center",
        scopedSlots: { customRender: "no" },
        width: 70,
      },
      {
        title: "Companion Name",
        key: "companion_nm",
        scopedSlots: { customRender: "companion_nm" },
        width: 150,
      },
      {
        title: "Contact Person",
        key: "contact_person",
        scopedSlots: { customRender: "contact_person" },
        width: 170,
      },
      {
        title: "Return Date",
        key: "return_dt",
        scopedSlots: { customRender: "return_dt" },
        align: "center",
        width: 120,
      },
      {
        title: "Methode",
        key: "methode",
        scopedSlots: { customRender: "methode" },
        width: 170,
      },
      {
        title: "Nominal",
        key: "nominal",
        scopedSlots: { customRender: "nominal" },
        width: 170,
      },
      {
        title: "Note",
        key: "note",
        dataIndex: "note",
        width: 170,
      },
      {
        title: "Action",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 100,
        align: "center",
        fixed: "right",
      },
    ];
    let doc_validation = (rule, value, callback) => {
      if (!this.isEdit && this.form.doc_dtl == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      columns,
      form: {
        doc_dtl: null,
        list_fk: [],
        type_companion: "FC",
        companion_nm: null,
        contact_person: null,
        //no_telp:null,
        nominal: null,
        return_dt: null,
        note: null,
        methode: null,
      },
      rules: {
        doc_dtl: [{ validator: doc_validation, trigger: "change" }],
        type_companion: {
          required: true,
          message: "Please Input Type Companion",
          trigger: "change",
        },
        companion_nm: {
          required: true,
          message: "Please Input Companion Name",
          trigger: "change",
        },
        contact_person: {
          required: true,
          message: "Please Input Contact person",
          trigger: "change",
        },
        // no_telp: {
        // required: true,
        //message: "Please Input no. Telp.",
        //trigger: "change",
        //},
        nominal: [
          {
            required: true,
            message: "Please Input Nominal",
            trigger: "blur",
          },
          { validator: this.validRatherThenzero },
        ],
        return_dt: {
          required: true,
          message: "Please Input Return Date",
          trigger: "change",
        },
        note: {
          required: false,
          message: "Please Input Note",
          trigger: "change",
        },
        methode: {
          required: true,
          message: "Please Input Method",
          trigger: "change",
        },
      },
      changeDetail: {
        selected: {},
        status: false,
      },
      isEdit: false,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDataDtlForm",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getScreen"
    ]),
  },
  mounted() {
  },
  methods: {
    moment,
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.form.doc_dtl = file;
        return false;
      }
    },
    handleSubmit() {
      this.$refs.detailsForm.validate((valid) => {
        if (!valid) {
          this.displayMessageValue(
            "basic-error",
            "Please complete Details Form"
          );
          return;
        }

        let data = {
          id_dtl: this.changeDetail.status
            ? this.changeDetail.selected.id_dtl
            : nanoid(),
          type_companion: this.form.type_companion,
          companion_nm: this.form.companion_nm,
          contact_person: this.form.contact_person,
          methode: this.form.methode,
          //no_telp: this.form.no_telp,
          nominal: this.form.nominal,
          return_dt: moment(this.form.return_dt, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          note: this.form.note,
        };

        if (this.changeDetail.status) {
          this.$store.commit("editDataDtlForm", data);
        } else {
          this.$store.commit("setDataDtlForm", data);
        }
        this.handleCancelEdit();

        this.$refs.detailsForm.resetFields();
      });
    },
    handleRemove(item) {
      if (this.changeDetail.status) {
        this.displayMessageValue(
          "basic-error",
          "complete your changing data first!"
        );
        return;
      }

      this.$store.commit("removeDataDtlForm", item);
    },
    handleView(item) {
      if (this.mode == "Create") {
        this.handlePDF(item.doc_dtl);
      } else {
        if (item.doc_dtl == null) {
          window.open(this.$serviceUrl + item.url);
        } else {
          this.handlePDF(item.doc_dtl);
        }
      }
    },
    removeUploadFile() {
      this.form.doc_dtl = null;
    },
    handleRef() {
      if (this.changeDetail.status) {
        this.displayMessageValue(
          "basic-error",
          "complete your changing data first!"
        );
        return;
      }

      if (this.getDataDtlForm.length == 0) {
        this.displayMessage("form-warning");
        return;
      }
      // console.log(this.getDataDtlForm)
      // let s = { jan : this.getDataDtlForm};
      Event.$emit("emitBidbondReq", this.getDataDtlForm);
    },
    handleEdit(item) {
      this.changeDetail = {
        selected: item,
        status: true,
      };

      this.form = {
        bulan: this.moment().month(parseFloat(item.bulan - 1)),
        tahun: item.tahun,
        pokok: item.pokok,
        bunga: item.bunga,

        type_companion: item.type_companion,
        companion_nm: item.companion_nm,
        contact_person: item.contact_person,
        //no_telp: item.no_telp,
        return_dt: moment(item.return_dt, 'YYYY-MM-DD'),
        nominal: item.nominal,
        note: item.note,
      };
    },
    handleCancelEdit() {
      this.$refs.detailsForm.resetFields();
      this.changeDetail = {
        selected: {},
        status: false,
      };
    },
    changeTypeCompanion() {
      this.form.methode = null
    }
  },
};
</script>

<style lang="less">
.ant-table-thead>tr>th {
  text-align: center;
}

.action {
  margin: 12px 0;
}

.table-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  list-style: none;
  text-align: right;
}

.doc-viewer {
  margin-top: 0.5em;
  border: 1px solid darken(white, 10);
  border-radius: 5px;
  padding: 5px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: darken(white, 2);
  position: relative;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  &:hover {
    border-color: @color-primary;
  }

  &.edit {
    align-items: center;
    padding: 5px;
    min-height: auto;

    .detail {
      flex: 1;
      flex-direction: row;
      justify-content: space-between;

      h4 {
        text-align: right;
      }
    }
  }

  .icon {
    font-size: 3.5em;
    color: orangered;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.5em;

    h4,
    small {
      text-transform: capitalize;
    }
  }

  .close {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
  }
}
</style>
